import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';

import BannerSection from './styles';

const Banner = memo(({ id, slot, sticky }) => {
  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('bn-slot-display', { detail: { 'bn-slots': [slot] } })
    );
  }, []);

  return (
    <BannerSection sticky={sticky}>
      <div id={id} data-bn-slot={slot} />
    </BannerSection>
  );
});

Banner.propTypes = {
  id: PropTypes.string.isRequired,
  slot: PropTypes.string.isRequired,
  sticky: PropTypes.bool,
};

Banner.defaultProps = {
  sticky: false,
};

export default Banner;
